"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _color = _interopRequireDefault(require("../../constants/color"));

var _styler = _interopRequireDefault(require("../Styler/styler"));

var _getNativeProps = _interopRequireDefault(require("../helpers/get-native-props"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Toolbar = function Toolbar(_ref) {
  var children = _ref.children,
      transparent = _ref.transparent,
      backgroundColor = _ref.backgroundColor,
      props = _objectWithoutProperties(_ref, ["children", "transparent", "backgroundColor"]);

  var allowedModifiers = {
    transparent: transparent
  };
  var toolbarClasses = ['co-toolbar', _defineProperty({}, backgroundColor, backgroundColor)];
  return _react.default.createElement(_styler.default, {
    classNames: toolbarClasses,
    modifiers: allowedModifiers
  }, function (styles) {
    return _react.default.createElement("div", _extends({
      className: styles
    }, (0, _getNativeProps.default)(props)), children);
  });
};

Toolbar.propTypes = {
  children: _propTypes.any.isRequired,
  transparent: _propTypes.bool,

  /** {const} Only accepts @@Color.background.white@@ */
  backgroundColor: (0, _propTypes.oneOf)([_color.default.background.white])
};
var _default = Toolbar;
exports.default = _default;
Toolbar.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Toolbar",
  "props": {
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": ""
    },
    "transparent": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "backgroundColor": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "Color.background.white",
          "computed": true
        }]
      },
      "required": false,
      "description": "{const} Only accepts @@Color.background.white@@"
    }
  }
};